import styled from 'styled-components';

export const Header = styled.div`
  background: ${(props) => props.theme.$steel_blue};
  color: ${(props) => props.theme.$white};
  border-top-left-radius: calc(0.3rem - 1px);
  border-top-right-radius: calc(0.3rem - 1px);

  .material-icons {
    font-size: 22px;
  }
`;
